import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    displayedChart:'h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood',
    charts:[
        { address: "h5NciPdMZ5QCB5BYETJMYBMpVx9ZuitR6HcVjyBhood", name: 'Robinhood' },
        { address: "Fx968z3Bfp8rn2BNqsTXv9Ym9QUdLk1GnQXpEx2Tpump", name: 'HeroesAI' },
        { address: "GkyZ3xtwoA35nTXE1t26uKGL6jjiC6zM9pGjvdtpump", name: 'seek16z' },
        { address: "KycTRqw5G2rTEjRXWK9JuzprBZLuYqV3yge3S2Rpump", name: 'PYTHON' },
        { address: "2sCUCJdVkmyXp4dT8sFaA9LKgSMK4yDPi9zLHiwXpump", name: 'ALPHA' },
      ],
    tokenData: {},
    loadingStates: {}, // Separate loading state per token
    errors: {} // Separate error state per token
  }


export const chartSlice = createSlice({
    name:'chart',
    initialState,
    reducers: {
        displayNewChart :(state, action) => {
            state.displayedChart = action.payload
        },
        removeSelectedChart :(state, action) => {
            let newState = state.charts.filter((chart)=> chart.address !== action.payload)
            state.charts = newState
        },
        addNewChart :(state, action) => {
            let found = state.charts.filter(c=>c== action.payload)
            if (found.length == 0) {
                state.charts = [...state.charts,action.payload]

            }else {
                return
            }
        },
      }
})


export const {displayNewChart,removeSelectedChart,addNewChart} = chartSlice.actions

export const selectedChart = (state)=>state.chart.displayedChart
export const openedCharts = (state)=>state.chart.charts
